module.exports = __webpack_public_path__ + "static/media/circle-info-icon.70bea18e.svg";